import { Component, OnInit } from '@angular/core';
import { version } from './../domain/publico';

@Component({
  selector: 'tis-foot',
  templateUrl: './tis.foot.html',
  styleUrls: ['./tis.foot.css']
})
export class Foot {
  version: string;
  currentDate = new Date();
  constructor() {
    this.version = version;
  }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/foot/tis.foot.ts